import React from "react";

const SVG = ({ width = "100%", className = "", viewBox = "0 0 12 12" }) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M6 12A6 6 0 1 1 6 0a6 6 0 0 1 0 12zm3.046-8.393-.653-.653L6 5.347 3.607 2.954l-.653.653L5.347 6 2.954 8.393l.653.653L6 6.653l2.393 2.393.653-.653L6.653 6l2.393-2.393z"
      fill="#8F8E9F"
      fillRule="nonzero"
    />
  </svg>
);

export default SVG;
